module.exports = __webpack_public_path__ + "static/21-04-02_13-12-31_4944-aed6f8d0799aec734590e849552d5be2.png";